import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { BaseComponentConfig, ComponentConfig, ActionState, MenuTitleOptions, ViewContainersService, UpdateComponentStoreService, UbsComponentStoreService, Relation, getFields } from '@urbannex/view-containers';
import { getColumnFieldTitles, getIdFieldName, getTarget } from '../../../products/configoptions';
import { ORDR_FORMS } from '../../forms';

@Component({
  selector: 'ubs-order-roles',
  templateUrl: './order-roles.component.html',
  styleUrls: ['./order-roles.component.scss']
})
export class OrderRolesComponent extends BaseComponentConfig implements OnInit{
  @Input() orderId:string;

  options:ComponentConfig = {
    name: '',
    title: '',
    standAlone: true,
    defaultParameters: [],
    defaultAction: ActionState.LIST,
    idFieldName: '',
    findForm: new OfbizForm,
    addForm: new OfbizForm,
    listForm: new OfbizList({
      listType: "grid",
      listFormName: "ListOrderRoles",
      listFormLocation: "component://kwikstore/widget/OrderViewForms.xml",
      columnFields: getFields("ListOrderRoles", ORDR_FORMS),
      columnFieldTitles: getColumnFieldTitles("ListOrderRoles", ORDR_FORMS),
      idFieldName: getIdFieldName("ListOrderRoles", ORDR_FORMS),
      target: getTarget("ListOrderRoles", ORDR_FORMS),
      viewIndex: 0,
      findParameters: [],
      appContext: "orders",
      remoteFormData: {
        formData: {
          formName: "ListOrderRoles",
          formLocation: "component://kwikstore/widget/OrderViewForms.xml",
          listType: "grid",
        }
      },
      emptyListMessage: "No Postal Address Found"
    }),
    addForms: [],
    listForms: [],
    actions: [],
    settings: [],
    summaryView: [],
    lookUpEndPoint: '',
    searchResults: undefined,
    breadCrumbData: undefined,
    childComponent: new ComponentConfig,
    customContainerItems: [],
    lookups: [],
    relations: [],
    appContext: '',
    outGoingLinks: [],
    tasks: [],
    menuAndTitleOptions: undefined,
    getMenuAndTitleOptions: function (): MenuTitleOptions {
      throw new Error('Function not implemented.');
    },
    masterDetails: [],
    selectedMasterDetails: undefined,
    setSelectedMasterDetails: function (selectedMasterDetails: Relation): void {
      this.selectedMasterDetails = selectedMasterDetails;
    },
    getSelectedMasterDetails: function (): Relation {
      return this.selectedMasterDetails;
    },
    selectedRelation: undefined,
    selectedTask: undefined
  }

  componentConfig:ComponentConfig;

  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService,
    private componentStore:UbsComponentStoreService) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    }

  ngOnInit(): void {
    this.options.listForm.findParameters.push({"orderId":this.orderId})
    this.componentConfig = new ComponentConfig(this.options);
    this.componentStore.updateComponentConfig(this.componentConfig);
    console.log(this.componentConfig);
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
  }
}
